<template>
	<div>
		<div class="vx-row mb-2">
			<div class="vx-col w-full">
				<vs-input class="w-full" label-placeholder="Vanaf welk bedrag is het gratis? (in centen)" v-model="shipping.free" />
			</div>
		</div>
		<div class="vx-row mb-2">
			<div class="vx-col w-full">
				<vs-input class="w-full" label-placeholder="Anders (in centen) voor normale zending" v-model="shipping.price" />
			</div>
		</div>
		<div class="vx-row mb-2">
			<div class="vx-col w-full">
				<vs-input class="w-full" label-placeholder="Anders (in centen) voor pallet zending" v-model="shipping.pallet_price" />
			</div>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full">
				<vs-button class="mr-3 mb-2" @click="saveShipping()" color="success">Opslaan</vs-button>
			</div>
		</div>
	</div>
</template>
<script>
	import api from '../api';
	export default {
		name: 'ShippingRules',
		components: {},
		props: {},
		data () {
			return {
				shipping: {}
			}
		},
		computed: {

		},
		mounted () {
			this.getShipping();
		},
		methods: {
			getShipping(){
				api.post("admin/settings", {keys: ['shipping']}).then(response=>{
					console.log(response);
					this.shipping = response.data[0].value;
				}).catch((error)=>{
					console.log(error);
				})
			},
			saveShipping(){
				api.put("admin/settings", {settings: {'shipping': this.shipping}}).then(()=>{
					this.$vs.dialog({
						title: 'Gelukt!',
						text: 'Opslaan van de verzondkosten regels is gelukt',
						color: 'success'
					})
				}).catch((error)=>{
					console.log(error);
				})
			},
		}
	}

</script>
